const messages = {
  more: '+',
  minus: '-',
}

export default messages
